import React, { useState } from "react";
import { filterModel } from "./filterModel";
import CheckBox from "../../controls/Checkbox";
import { getNewFilterObject } from "./helperFilter";
import './style.css'

const FilterBody = (props) => {

    const [filter, setFilter] = useState({});

    const changeFilter = (payload) => {

        const oldFilter = {...filter}
        const newFilter = getNewFilterObject(oldFilter, payload)

        // setFilter(
        //     {
        //         ...filter, 
        //         [filterName]: [
        //             ...filter[filterName],
        //             id
        //         ]
        //     }
        // )
    }

    return (
        <div className="filter">
            <div className='filter__checbox-list'>
                {filterModel.typeObjects.map((item) => {
                    return (
                       <CheckBox 
                            name={item.name}
                            category
                            id={item.id}
                            key={item.id}
                            onChange={(payload) => changeFilter(payload)}
                            type={'typeObject'}
                        />
                    )
                })}
            </div>

            <div className='filter__buttons-panel'>
                <div className="filter__btn">
                    Очистить
                </div>
                <div onClick={(e) => props.changeFilter()} className="filter__btn filter-btn_apply">
                    Поиск
                </div>
            </div>
        </div>
    )
}

export default FilterBody;